const ChooseInput = ({ value, label, name, onChange }) => (
    <div className="choose-input-group">
        <input
            type="radio"
            value={value}
            name={name}
            id={name + '-' + value}
            className="choose-input choose-input--hide"
            onChange={onChange}
        />{label && <label htmlFor={name + '-' + value}>{label}</label>}
    {/*  error message here  */}
    </div>
);

export default ChooseInput;